<div class="card flex flex-col justify-content-center w-full">
    <label *ngIf="labelText" class="mb-2 text-sm font-medium text-black" [for]="datalistId">
        {{ labelText }}
    </label>

    <div class="relative flex items-center border border-border rounded-[10px] w-full focus:ring-2 focus:ring-primary focus:outline-none hover:cursor-text"
        [ngClass]="[boxHeight, isDisabled ? 'hover:cursor-not-allowed' : '']">
        <input type="text" class="input w-full h-full p-2" [id]="datalistId" [attr.list]="datalistId + '-list'"
            [placeholder]="placeholder" [disabled]="isDisabled" [value]="inputValue" (input)="onInputChange($event)"
            [class.text-neutral-800]="isDisabled" [title]="getTitle" />
        
        <svg class="absolute right-3 top-1/2 transform -translate-y-1/2 pointer-events-none w-4 h-4 text-gray-500" 
             fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 9l-7 7-7-7" />
        </svg>

        <datalist [id]="datalistId + '-list'">
            <option *ngFor="let option of filteredSuggestions" [value]="labelRenderer(option)"></option>
        </datalist>
    </div>

    <div *ngIf="errorMessage" class="flex items-center text-error mt-2 text-sm">
        <img src="assets/icons/close-circle.svg" alt="Error" class="w-5 h-5" />
        <p class="ml-1">{{ errorMessage }}</p>
    </div>
</div>